import { render, staticRenderFns } from "./PageCheckBox.vue?vue&type=template&id=f57c9526&scoped=true&"
import script from "./PageCheckBox.vue?vue&type=script&lang=js&"
export * from "./PageCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./PageCheckBox.vue?vue&type=style&index=0&id=f57c9526&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57c9526",
  null
  
)

export default component.exports